import { render, staticRenderFns } from "./ShareDetails.vue?vue&type=template&id=f01cf620"
import script from "./ShareDetails.vue?vue&type=script&lang=js"
export * from "./ShareDetails.vue?vue&type=script&lang=js"
import style0 from "./ShareDetails.vue?vue&type=style&index=0&id=f01cf620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports